export const arrowsSort = (
  <svg
    id="Order_by"
    data-name="Order by"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="33"
    viewBox="0 0 24 33"
  >
    <g id="arrow_drop_up_24px">
      <rect id="Boundary" width="24" height="24" fill="none" />
      <path
        id="_Color"
        data-name=" ↳Color"
        d="M0,5,5,0l5,5Z"
        transform="translate(7 9)"
        fill="rgba(255,255,255,0.87)"
      />
    </g>
    <g id="arrow_drop_down_24px" transform="translate(0 9)">
      <rect
        id="Boundary-2"
        data-name="Boundary"
        width="24"
        height="24"
        fill="none"
      />
      <path
        id="_Color-2"
        data-name=" ↳Color"
        d="M0,0,5,5l5-5Z"
        transform="translate(7 10)"
        fill="rgba(255,255,255,0.87)"
      />
    </g>
  </svg>
);
